import { FeatureName } from '../../graphql';

export interface Feature {
  id: string;
  name: FeatureName;
  enabled: boolean;
  description: string;
  workspaces?: Array<{ id: string }>;
  accounts?: Array<{ id: string }>;
}
